module.exports = __webpack_public_path__ + "static/media/parcerias-sustentaveis.c6949cb3.svg";